export const ChatClosedNotice = () => (
  <div className="border-t border-gray-200 bg-gray-50 px-3 py-3 text-center text-xs font-semibold text-black04">
    Este chamado foi encerrado. Não é possível enviar novas mensagens.
  </div>
)
